export default __webpack_public_path__ + "static/media/biodata-6.515d8a11.png";